module.exports = __webpack_public_path__ + "static/media/notfound_background.517515b4.png";